window.onRecaptchaSuccess = function () {
  const captcha = document.querySelector(".g-recaptcha");
  const wrapper = captcha?.closest(".re-captcha-wrap");
  const errorDiv = wrapper?.querySelector(".error-message");

  if (errorDiv) errorDiv.textContent = "";
  wrapper?.classList.remove("error-outer");
};

document.addEventListener("DOMContentLoaded", function () {

  const form = document.getElementById("support-form");
  if (!form) return;

  const thankYouSection = document.getElementById("success-section");
  if (thankYouSection) thankYouSection.style.display = "none";

  /* ========================
     Fields
  ======================== */

  const fields = {
    firstname: form.querySelector("input[name='firstname']"),
    lastname: form.querySelector("input[name='lastname']"),
    email: form.querySelector("input[name='email']"),
  };

  const consentCheckbox = form.querySelector(".required-checkbox");
  const consentWrapper = consentCheckbox?.closest(".custom-field");
  const errorClass = 'error-highlight';
  /* ========================
     Validators
  ======================== */

  const validators = {
    firstname: val => val.length >= 2,
    lastname: val => val.length >= 1,
    email: val => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val),
  };

  const messages = {
    firstname: ["This field cannot be empty", "First name is too short"],
    lastname: ["This field cannot be empty"],
    email: ["This field cannot be empty", "Email is not valid"]
  };

  /* ========================
     Live validation
  ======================== */

  Object.entries(fields).forEach(([key, field]) => {
    if (!field) return;

    field.addEventListener("input", () => {
      const val = field.value.trim();

      if (!val) {
        showError(field, messages[key][0]);
      } else if (!validators[key](val)) {
        showError(field, messages[key][1] || messages[key][0]);
      } else {
        clearError(field);
      }
    });
  });

  consentCheckbox.addEventListener('change', function () {
      if (consentCheckbox.checked) {
        consentWrapper.classList.remove(errorClass);
      }else{
        consentWrapper.classList.add(errorClass);
      }
    });
  /* ========================
     Submit handler
  ======================== */

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    let valid = true;

    // Validate fields
    Object.entries(fields).forEach(([key, field]) => {
      if (!field) return;
      const val = field.value.trim();

      clearError(field);

      if (!val) {
        showError(field, messages[key][0]);
        valid = false;
      } else if (!validators[key](val)) {
        showError(field, messages[key][1] || messages[key][0]);
        valid = false;
      }
    });

    // Validate consent
    if (!consentCheckbox?.checked) {
      consentWrapper?.classList.add("error-highlight");
      valid = false;
    } else {
      consentWrapper?.classList.remove("error-highlight");
    }

    // // Validate reCAPTCHA
    // if (typeof grecaptcha !== "undefined") {
    //   const recaptchaResponse = grecaptcha.getResponse();
    //   if (!recaptchaResponse.length) {
    //     valid = false;
    //   }
    // }

    if (!valid) {
      const firstError = form.querySelector(".error-message:not(:empty)");
      firstError?.closest(".form-control, .custom-field, .re-captcha-wrap")
        ?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    /* ========================
       HE-1 Payload (fixed)
    ======================== */

    const payload = {
      language: form.elements["language"]?.value || "en",
      request_type: form.elements["request_type"].value,
      firstname: fields.firstname.value,
      lastname: fields.lastname.value,
      email: fields.email.value,
      phone: form.elements["phone"]?.value || "",
      country: form.elements["country"]?.value || "",
      city: form.elements["city"]?.value || "",
      //terms: form.elements["terms"]?.checked ? "terms" : "",
      //"g-recaptcha-response": grecaptcha.getResponse()
    };

    console.log("payload=>",payload);
    
    try {
      const response = await fetch(
        "https://www.sennheiser-hearing.com/.netlify/functions/sendSupportRequest",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        }
      );

      if (response.ok) {
        form.style.display = "none";
        if (thankYouSection) thankYouSection.style.display = "block";
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("HE-1 form error:", error);
      alert("Submission failed. Please try again later.");
    }
  });

  /* ========================
     Helpers
  ======================== */

  function showError(field, msg) {
    const wrapper = field.closest(".form-control, .re-captcha-wrap");
    const errorDiv = wrapper?.querySelector(".error-message");

    if (errorDiv) errorDiv.textContent = msg;
    wrapper?.classList.add("error-outer");
  }

  function clearError(field) {
    const wrapper = field.closest(".form-control, .re-captcha-wrap");
    const errorDiv = wrapper?.querySelector(".error-message");

    if (errorDiv) errorDiv.textContent = "";
    wrapper?.classList.remove("error-outer");
  }

});
